import moment from 'moment';

import { PriceChartPeriod } from '../../../shared/types';
import { PriceDataPoint } from '../../../types';

export const calcDataZoomStartPercentage = (
  priceData: ReadonlyArray<PriceDataPoint>,
  selectedPeriodPreset: PriceChartPeriod,
  rightSideOffset: number, // number of data points at the right side of the right most candlestick
  leftSideOffset: number // number of data points at the left side of the right most candlestick
): number => {
  let windowSize = 1;
  while (priceData.length > windowSize) {
    const latestDate = moment.utc(priceData.at(-1).date);
    const diff = latestDate.diff(
      moment.utc(priceData[priceData.length - windowSize].date),
      'months',
      true
    );
    if (selectedPeriodPreset === '1m' && diff >= 1) break;
    if (selectedPeriodPreset === '3m' && diff >= 3) break;
    if (selectedPeriodPreset === '6m' && diff >= 6) break;
    if (selectedPeriodPreset === '1y' && diff >= 12) break;
    windowSize++;
  }
  return (
    ((priceData.length + leftSideOffset - windowSize) /
      (priceData.length + rightSideOffset + leftSideOffset)) *
    100
  );
};

const isBarSeries = (
  series: echarts.EChartOption.Series
): series is echarts.EChartOption.SeriesBar => series.type === 'bar';

export const optimizeSeriesWhenZoomingOut = (
  series: echarts.EChartOption.Series
): echarts.EChartOption.Series => {
  if (isBarSeries(series)) {
    // hide the bar labels when the chart is zoomed out
    // because the the bars are too dense to display the texts properly.
    return {
      ...series,
      label: { show: false },
    };
  }
  return series;
};
